import type { BundleProduct, StandardProduct } from '#shared/types/goliath/goliath.types';

export function recordHasUsps(obj: Offer | StandardProduct | BundleProduct | null | undefined) {
  return !!obj?.usps && obj.usps.length > 0;
}

export function offerHasOwnUsps(offer: Offer) {
  return recordHasUsps(offer);
}

export function offerHasProductUsps(offer: Offer) {
  const { product } = offer;
  if (!product) return false;

  const bundleProduct = getBundleProduct(product);
  if (bundleProduct) {
    return bundleProduct.bundledProducts?.some((p) => recordHasUsps(p));
  }

  return recordHasUsps(product);
}

export function offerHasUsps(offer: Offer) {
  return offerHasOwnUsps(offer) || offerHasProductUsps(offer);
}
